import React, { useEffect, useRef, useState } from 'react';
import { isPrerender } from '../Utility/prerender';

// Fades a block in when it scrolls into view. Content stays visible without JavaScript.
// Styles (.ind-reveal) live in CSS/Industry.css.
const Reveal: React.FC<{ className?: string; children: React.ReactNode }> = ({ className = '', children }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [armed, setArmed] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === 'undefined' || isPrerender()) return;
    setArmed(true);
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref} className={`ind-reveal${armed ? ' armed' : ''}${visible ? ' in-view' : ''} ${className}`}>
      {children}
    </div>
  );
};

export default Reveal;
